import { useCallback, useEffect, useRef, useState } from "react";

// Uma consulta por recurso, preservando o último resultado quando a rede falha.
export function useAdminResource(fetcher, interval = 60000) {
  const [state, setState] = useState({ data: null, loading: true, refreshing: false, error: "", updatedAt: null });
  const mounted = useRef(false);
  const pending = useRef(null);
  const reload = useCallback(() => {
    if (pending.current) return pending.current;
    setState(s => ({ ...s, refreshing: true }));
    pending.current = Promise.resolve().then(fetcher).then(data => {
      if (mounted.current) setState({ data, loading: false, refreshing: false, error: "", updatedAt: new Date().toISOString() });
      return data;
    }).catch(error => {
      if (mounted.current) setState(s => ({ ...s, loading: false, refreshing: false, error: error.message || "Falha ao carregar. Tente novamente." }));
      return null;
    }).finally(() => { pending.current = null; });
    return pending.current;
  }, [fetcher]);
  useEffect(() => {
    mounted.current = true;
    reload();
    const visible = () => { if (document.visibilityState === "visible") reload(); };
    const timer = interval ? setInterval(visible, interval) : null;
    if (interval) document.addEventListener("visibilitychange", visible);
    return () => { mounted.current = false; clearInterval(timer); document.removeEventListener("visibilitychange", visible); };
  }, [reload, interval]);
  return { ...state, reload };
}
export function useAdminAction() {
  const lock = useRef(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  async function run(action, success = "Alteração concluída.") {
    if (lock.current) return false;
    lock.current = true; setBusy(true); setError(""); setNotice("");
    try { await action(); setNotice(success); return true; }
    catch (e) { setError(e.message || "Não foi possível concluir. Tente novamente."); return false; }
    finally { lock.current = false; setBusy(false); }
  }
  return { busy, error, notice, run, setError, setNotice };
}
